var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:(_vm.collectionSlug + "Wave"),staticClass:"wave"},[_c('canvas',{ref:(_vm.collectionSlug + "Canvas"),staticClass:"wave__canvas",attrs:{"id":(_vm.collectionSlug + "-canvas")}})])}
var staticRenderFns = []

export { render, staticRenderFns }